// extracted by mini-css-extract-plugin
export default {"containerBtnInstalar":"instalar_containerBtnInstalar__l0kjM","setaImg":"instalar_setaImg__3F6nG"};